<template>
  <div class="col">
    <p class="mb-1">
      <u>{{ response.Question }}</u>
    </p>

    <div
      class="px-2 py-2"
      style="border: 0.1rem solid gray; border-radius: 4px;"
    >
      <h5>{{ response.Response.t }}</h5>
      <h6>{{ response.Response.s }}</h6>
      <table class="table">
        <tbody>
          <tr
            v-for="(row, rowindex) in response.Response.r"
            :key="rowindex"
            v-bind:class="{ 'header-row': row.h == true }"
            v-bind:id="'row' + rowindex"
          >
            <td
              v-for="(col, index) in row.c"
              :key="index"
              v-bind:colspan="col.cs ? col.cs : 1"
            >
              <div v-if="col.i == 'd'" class="input-group">
                <p>${{ col.v }}</p>
              </div>
              <div v-else>
                <p v-if="col.sum">
                  {{
                    $updateBudgetCol(
                      col,
                      row.c[index - 2].v * row.c[index - 1].v
                    )
                  }}
                </p>
                <p v-else-if="col.st">
                  {{
                    $updateBudgetCol(
                      col,
                      $getBudgetSectionTotal(response.Response.r, row.c[0].v)
                    )
                  }}
                </p>
                <p v-else v-html="checkForKeyword(col.v)"></p>
              </div>
            </td>
          </tr>
          <tr v-if="response.Response.r.length > 0" class="header-row">
            <td v-bind:colspan="response.Response.r[0].c.length - 1">
              Total
            </td>
            <td>{{ $getBudgetTotal(response.Response.r) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "BudgetTemplateBody",
  components: {},
  props: {
    Response: Object,
    Keywords: Array
  },
  data() {
    return {
      response: this.Response,
      terms: this.Keywords ? this.Keywords.map(t => t.Name) : []
    };
  },
  mounted() {
    var responseLength = this.Response.Response.r.length;
    var CONTROL_INTERVAL = setInterval(function() {
      if ($("#row" + responseLength).length == 1) {
        $('[data-toggle="popover"]').popover();
        $(".popover-dismiss").popover({
          trigger: "focus"
        });
        clearInterval(CONTROL_INTERVAL);
      }
    }, 100);
  },
  methods: {
    checkForKeyword(text) {
      var returnText = text;
      if (this.Keywords && this.Keywords.length > 0) {
        this.terms.forEach(term => {
          if (text.includes(term)) {
            returnText = returnText.replace(
              term,
              '<button type="button" class="btn btn-link py-0 px-0" style="border-width: 0px; vertical-align: top;" data-toggle="popover" data-trigger="focus" title="' +
                term +
                '" data-content="' +
                this.Keywords.find(t => t.Name == term).Definition +
                '">' +
                term +
                "</button>"
            );
          }
        });
      }
      return returnText;
    }
  }
};
</script>
